'use client';

import { useState, type ReactNode } from 'react';
import { cn } from '@/lib/utils';
import '../sidebar.css';

type SidebarState = { expanded: boolean; pinned: boolean; toggle: () => void };

/** The same compact, hover-expand and click-to-pin rail in Home and Studio. */
export function NavigationSidebar({ label, children, className, defaultPinned = false }: { label: string; children: (state: SidebarState) => ReactNode; className?: string; defaultPinned?: boolean }) {
  const [pinned, setPinned] = useState(defaultPinned), [hovered, setHovered] = useState(false), [keyboardFocus, setKeyboardFocus] = useState(false);
  const expanded = pinned || hovered || keyboardFocus;
  const toggle = () => { setPinned(value => !value); setHovered(false); setKeyboardFocus(false); };
  return <aside aria-label={label} className={cn('platform-sidebar-desktop', className)} data-expanded={expanded} data-pinned={pinned}
    onMouseEnter={() => { if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) setHovered(true); }} onMouseLeave={() => setHovered(false)}
    onFocusCapture={event => { if (event.target.matches(':focus-visible')) setKeyboardFocus(true); }} onBlurCapture={event => { if (!event.currentTarget.contains(event.relatedTarget)) setKeyboardFocus(false); }}
    onKeyDown={event => { if (event.key === 'Escape') { setPinned(false); setHovered(false); setKeyboardFocus(false); } }}>
    {children({ expanded, pinned, toggle })}
  </aside>;
}
